import { ConfigProvider } from 'antd';
import "react-loading-skeleton/dist/skeleton.css";
import './App.css';
import RootRouter from './routes';
import Auth from './shared/rbac/provider';
import theme from './shared/theme';

function App() {
  return (
    <Auth>
      <ConfigProvider theme={theme}>
        <RootRouter />
      </ConfigProvider>
    </Auth>
  );
}



export default App;
